import { useEffect } from "react";
import { Link } from "react-router-dom";

import { PageShell } from "../components/PageShell.js";
import { Seo } from "../components/Seo.js";

export function CoreCommittee() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <PageShell>
      <Seo
        title="JivaSeva Core Committee · JivaSeva"
        description="The volunteer-led JivaSeva Core Committee stewards the initiative's founding vision and guiding principles, ensuring services and projects stay aligned with Life Takes Care of Life."
        path="/app/core-committee"
      />
      <h1 className="page-heading">JivaSeva Core Committee</h1>

      <section className="about-section">
        <p className="manifesto">
          <span className="brand-name">JivaSeva</span> is supported by a
          volunteer-led Core Committee that serves as the steward of its founding
          vision and guiding principles.
        </p>
        <p className="manifesto">
          The Core Committee exists to help ensure that initiatives, services,
          and projects developed under the JivaSeva name remain aligned with the
          spirit of <strong>Life Takes Care of Life</strong>. It also provides
          continuity as JivaSeva grows and new opportunities for service emerge.
        </p>
        <p className="manifesto">
          Core Committee members serve entirely as volunteers. They receive no
          salary or financial compensation for their role and are expected to act
          in the best interests of JivaSeva and the communities it serves.
        </p>
        <p className="manifesto">
          JivaSeva welcomes volunteers from all backgrounds. Volunteers who
          demonstrate sustained commitment to JivaSeva's mission and values may
          express interest in serving on the Core Committee. Membership and
          succession are determined by the existing Core Committee to help
          preserve the long-term vision and integrity of the initiative.
        </p>
        <p className="manifesto">
          For more information about the JivaSeva Core Committee or its
          responsibilities, please contact us through the{" "}
          <Link to="/contact" className="inline-link">
            Contact page
          </Link>
          .
        </p>
      </section>
    </PageShell>
  );
}
